module.exports = __webpack_public_path__ + "img/finance.a29631ba.svg";